<section class="blogpost-editor-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">Markdown blogpost</p>
      <h1>{{ pageTitle }}</h1>
      @if (siteName) {
        <p class="context-site">Viewing <strong>{{ siteName }}</strong></p>
      }
      <p class="intro">Write a single markdown body and keep article metadata in simple fields.</p>
    </div>
    <a class="ghost" routerLink="/blogposts">Back to blogposts</a>
  </header>

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (!sites.length) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Sites</p>
          <h2>No sites available</h2>
        </div>
        <a class="accent" routerLink="/sites">Manage sites</a>
      </header>
      <p class="empty-state">Create a site before opening the blogpost editor.</p>
    </section>
  } @else if (loading) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Loading</p>
          <h2>Preparing markdown workspace</h2>
        </div>
      </header>
      <p class="empty-state">Loading blogpost...</p>
    </section>
  } @else if (blogpost) {
    <section class="editor-panel">
      <div class="editor-grid">
        <label>
          <span>Title</span>
          <input [ngModel]="blogpost.title" (ngModelChange)="updateTitle($event)" placeholder="Blogpost title" />
        </label>

        <label>
          <span>Slug</span>
          <input [(ngModel)]="blogpost.slug" spellcheck="false" placeholder="blogpost-slug" />
        </label>

        <label class="full-field">
          <span>Summary</span>
          <textarea [(ngModel)]="blogpost.metadata.summary" rows="3" placeholder="Short summary for feeds and listings"></textarea>
        </label>

        <label>
          <span>Meta title (optional)</span>
          <input [(ngModel)]="blogpost.metadata.metaTitle" placeholder="SEO title" />
        </label>

        <label>
          <span>Meta image URL (optional)</span>
          <input [(ngModel)]="blogpost.metadata.metaImageUrl" type="url" inputmode="url" placeholder="https://example.com/image.jpg" />
        </label>

        <label class="full-field">
          <span>Meta description (optional)</span>
          <textarea [(ngModel)]="blogpost.metadata.metaDescription" rows="2" placeholder="SEO description"></textarea>
        </label>

        <div class="full-field">
          <cms-tag-selector
            [tags]="blogpost.tags"
            [suggestions]="tagSuggestions"
            placeholder="Add blogpost tags"
            (tagsChange)="blogpost.tags = $event" />
        </div>

        <label class="publish-toggle">
          <input type="checkbox" [(ngModel)]="blogpost.published" />
          <span>Published</span>
        </label>
      </div>

      <section class="markdown-panel">
        <header class="markdown-toolbar">
          <div>
            <p class="eyebrow">Markdown</p>
            <h2>Post body</h2>
          </div>
        </header>
        <textarea
          class="markdown-editor"
          [(ngModel)]="blogpost.content"
          rows="24"
          spellcheck="false"
          placeholder="# Heading&#10;&#10;Write the blogpost in markdown."></textarea>
      </section>

      <div class="editor-actions">
        <button type="button" class="accent" [disabled]="saving || !canSubmitBlogpost" (click)="saveBlogpost()">
          {{ saving ? 'Saving...' : (isCreateMode ? 'Create blogpost' : 'Save blogpost') }}
        </button>
        @if (!isCreateMode) {
          <button type="button" class="danger" [disabled]="saving" (click)="deleteBlogpost()">Delete blogpost</button>
        }
      </div>
    </section>
  }
</section>
